import React, { useState } from 'react';
import { VISION_TABS } from '../data/mock';

const VisionTabs = () => {
  const [active, setActive] = useState('vision');
  const tab = VISION_TABS.find((t) => t.key === active);

  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto px-6 -mt-14 md:-mt-16 relative z-10">
        <div className="grid grid-cols-3">
          {VISION_TABS.map((t) => (
            <button key={t.key} onClick={() => setActive(t.key)}
              className={`py-6 md:py-7 text-sm md:text-lg font-semibold transition-colors ${active === t.key ? 'bg-white text-slate-900' : 'bg-[#2BBECF] text-white hover:bg-[#1ca6b6]'}`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 py-16 md:py-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <h3 className="heading-display text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
            {tab.title}
            <br />
            <span className="text-[#F97559]">{tab.subtitle}</span>
          </h3>
          <p className="mt-6 text-slate-600 leading-8 text-[15px]">{tab.body}</p>
        </div>
        <div className="relative h-[420px] md:h-[480px]">
          <div className="absolute inset-0 overflow-hidden rounded-sm shadow-xl">
            <img src={tab.image} alt={tab.title} className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[#F97559] text-white grid place-items-center heading-display text-5xl font-bold shadow-xl">
            {tab.letter}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionTabs;
